/**
 * Sentry init for unity/base Vite SPA.
 * Replaces @sentry/nextjs (ADR-020, E32 T-3902).
 * Called at the top of src/main.tsx before render.
 */

import * as Sentry from '@sentry/react'

const dsn = import.meta.env['VITE_SENTRY_DSN'] as string | undefined

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.05,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  })
}

export { Sentry }
